// import React from "react";
// import DynamicCarousel from "../../components/DynamicCarousel";
// import { Box } from "@mui/material";

// type Props = {};

// const MissionAndVission = (props: Props) => {
//   return (
//     <Box sx={{ border: "1px solid red" }}>

//     </Box>
//   );
// };

// export default MissionAndVission;


import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import rawData from "../../data/about/visionMission.json";

type VisionMissionData = {
  title: string;
  visionTitle: string;
  vision: string;
  missionTitle: string;
  mission: string;
  mottoTitle: string;
  motto: string;
};

const visionMissionConstants = rawData as VisionMissionData;

type Props = {};

const MissionAndVision = (props: Props) => {
  const isSmallScreen = useMediaQuery("(max-width:650px)");

  return (
    <Stack direction="column" spacing={3}>
      <Typography variant="h4" sx={{ fontFamily: "inherit" }}>
        {visionMissionConstants.title}
      </Typography>

      <Stack direction="column" spacing={2} sx={{ mt: isSmallScreen ? 2 : 3 }}>
        <Typography
          variant="h6"
          sx={{ fontFamily: "inherit", fontWeight:"bold",  }}
          textAlign="justify"
        >
          {visionMissionConstants.visionTitle}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontFamily: "inherit" }}
          textAlign="justify"
        >
          {visionMissionConstants.vision}
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontFamily: "inherit", mt: 0,  fontWeight:"bold" }}
          textAlign="justify"
        >
          {visionMissionConstants.missionTitle}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontFamily: "inherit" }}
          textAlign="justify"
        >
          {visionMissionConstants.mission}
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontFamily: "inherit", mt: 0, fontWeight:"bold" }}
          textAlign="justify"
        >
          {visionMissionConstants.mottoTitle}
        </Typography>
        <Box sx={{ mb: 0 }}>
          <Typography
            variant="body2"
            sx={{ fontFamily: "inherit", mb: 5 }}
            textAlign="justify"
          >
            {visionMissionConstants.motto}
          </Typography>
        </Box>
        {/* <Typography
          variant="body2"
          sx={{
            fontFamily: "inherit",
            fontStyle: "italic",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          “{visionMissionConstants.motto}”
        </Typography> */}
      </Stack>
    </Stack>
  );
};

export default MissionAndVision;
